import _asyncToGenerator from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.slice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import IconSetting from '@/gikam/js/components/icon/vue/IconSetting';
import IconList from '@/gikam/js/components/icon/vue/IconList';
import settingToolbar from '@/gikam/js/components/pageEdit/vue/settingToolbar';
import IconPlus from '@/gikam/js/components/icon/vue/IconPlus';
import { Sequence } from '@/gikam/js/core/sequence';
import Gikam from 'gikam';
export default {
  components: {
    IconSetting: IconSetting,
    IconList: IconList,
    settingToolbar: settingToolbar,
    IconPlus: IconPlus
  },
  props: {
    options: Object
  },
  data: function data() {
    return {
      active: true
    };
  },
  computed: _objectSpread({}, mapState(['$window', 'form'])),
  watch: {
    active: function active(value) {
      if (value === false) {
        this.$emit('update:showPageEditWrapper', false);
      }
    }
  },
  created: function created() {
    this.$window.activePageEditSettingItem(this);
  },
  methods: {
    settingClickHandle: function settingClickHandle() {
      this.$window.openSettingPanel({
        title: this.$i18n('pageEdit.form.setting'),
        type: 'formSetting',
        options: this.options
      });
    },
    addFieldHandle: function addFieldHandle() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var lastPanel, key, options, wrapper;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                lastPanel = _this.options.panels.slice(-1)[0];
                key = Sequence.nextWithTime();
                options = {
                  field: '',
                  key: key,
                  title: _this.$i18n('pageEdit.form.title.newInsert'),
                  type: 'text',
                  appendField: true
                };
                lastPanel.fields.push(options);
                _context.next = 6;
                return _this.$nextTick();

              case 6:
                wrapper = _this.form.formGroupManager[key].$refs['wrapper'];
                Gikam.simulatedEvent(wrapper.$el, 'mousedown');
                setTimeout(function () {
                  _this.$window.openSettingPanel({
                    title: _this.$i18n('pageEdit.form.field.setting'),
                    type: 'formFieldSetting',
                    options: options
                  });
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    showHiddenFieldsHandle: function showHiddenFieldsHandle() {
      this.$window.openSettingPanel({
        position: 'left',
        title: this.$i18n('pageEdit.form.hidden.fields'),
        type: 'formHiddenFields',
        options: this.form.options.hiddenFields
      });
    }
  }
};